import React from "react"
import {FieldGlistGroupProps} from "../../../../../render/glist/glist-group";

export default function FieldDropdown_GlistGroupStandard(props:FieldGlistGroupProps) {

    //For only Boolean values( Why value is string??? )
    if(props.data.value === "true"){
        props.data.value = true
    }

    if(props.data.value === "false"){
        props.data.value = false
    }
    ///////////

    const option = props.field._getOption(props.data.value)

    // const groupColor = _.get(option, 'color', null);
    const groupColor = null;
    const groupName = _.get(option, 'label', props.field.noValueOptionLabel);

    const colorClass: string    = groupColor ? 'gd-c-{0}'.f(groupColor) : ''
    const classes: string       = Classes("group-cards", colorClass, {
        'colored-background': !!colorClass,
    })

    return (
        <div className={classes}>
            <div className="text">{groupName}</div>
            {!!props.data.isCollapsed && <div className="counter">{props.data.counter}</div>}

            {!props.data.isCollapsed &&
                <div className="group-corners">
                    <div className={Classes("top-corner", colorClass)}/>
                </div>}
        </div>
    )
}
